export default __webpack_public_path__ + "static/media/vision.9af86e83.jpg";